import About from './About';
import Organizers from './Organizers';
import Registration from './Registration';
import Program from './Program';
import Materials from './Materials';

function Main() {
  return (
    <>
      <main>
        <About />
        <Organizers />
        <Registration />
        <Program />
        <Materials />
      </main>
    </>
  );
}
export default Main;
